/* eslint-disable no-restricted-globals */
import { useState, useRef, useMemo, useCallback } from "react";
import DataTable from "../Table/Datatable.js";
import { format as dateFormat } from "date-fns";
import { useEffect } from "react";
import { DOMAIN_API_HOST } from "../../../configs/main.js";
import "./reach.scss";
import { INIT_FILTER_VALUE, filterDate, filterEmploye, filterStatsDate, filterStatsPartner } from "./filters.js";
import { Modal, Box, Typography, MenuItem } from "@material-ui/core";
import { FormControl, InputLabel, Select, ListSubheader, InputAdornment, TextField, Checkbox, Button, IconButton, CircularProgress } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import DateFromTo from "../../../widgets/DateFromTo/DateFromTo.js";
import ProjectSelect from "../../../widgets/ProjectSelect/ProjectSelect";
import { Switch } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { regionsData } from "./geolist.js";
import { citiesByRegions } from "../Ssp/citiesByRegions.js";
import Chip from "@mui/material/Chip";
import * as z from "zod";
import { AdsForManagers } from "../../../components/addCompany/stages/Banners/newBanner/Ads";

const styles = {
  maxHeight: "600px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const postviewStyles = {
  maxHeight: "1000px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  maxWidth: "80%",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const decisionStyles = {
  maxHeight: "550px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};


const defaultStyles = {
  maxHeight: "800px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  padding: "32px",
};


const campaignStyles = {
  maxHeight: "600px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};


const RegionSelect = ({ defaultValue, regions, handleChange, campaign_id, field = "ssp_geo" }) => {
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (defaultValue) {
      setSelectedRegions(defaultValue.split(","));
    }
  }, [defaultValue]);

  const toggleRegion = (regionId) => {
    setSelectedRegions((prevSelected) => {
      const newSelected = prevSelected.includes(regionId)
        ? prevSelected.filter((id) => id !== regionId)
        : [...prevSelected, regionId];
      handleChange(field, newSelected.join(","), campaign_id);
      return newSelected;
    });
  };

  const selectAll = () => {
    const allRegionIds = Object.keys(regions);
    setSelectedRegions(allRegionIds);
    handleChange(field, allRegionIds.join(","), campaign_id);
  };

  const deselectAll = () => {
    setSelectedRegions([]);
    handleChange(field, "", campaign_id);
  };

  const filteredRegions = Object.entries(regions).filter((entry) =>
    entry[1].toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleRemoveRegion = (regionId) => {
    setSelectedRegions((prevSelected) => {
      const newSelected = prevSelected.includes(regionId)
        ? prevSelected.filter((id) => id !== regionId)
        : [...prevSelected, regionId];
      handleChange(field, newSelected.join(","), campaign_id);
      return newSelected;
    });
  };

  return (
    <Box sx={{ width: 230, padding: "10px 0", textAlign: "start" }}>
      <FormControl fullWidth size="small">
        <InputLabel>Выбор {field === "ssp_geo" ? "региона" : "города"}</InputLabel>
        <Select
          multiple
          onOpen={() => setTimeout(() => document.getElementById("search-input-regions").focus(), 100)}
          value={selectedRegions}
          renderValue={(selected) => selected.map((id) => regions[id]).join(", ")}
          style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
          sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
          onClose={() => setTimeout(() => setSearchQuery(""), 100)}
        >
          <ListSubheader>
            <Box sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mb: 1,
              maxWidth: "500px",
              maxHeight: "300px",
              overflowY: "auto",
              "&::-webkit-scrollbar": { display: "none" },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none"
            }}>
              {selectedRegions.map((regionId) => (
                <Chip
                  key={regionId}
                  label={regions[regionId]}
                  onDelete={() => handleRemoveRegion(regionId)}
                  style={{ border: "2px solid #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                />
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 5, mb: 1 }}>
              <button onClick={selectAll} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Выбрать все
              </button>
              <button onClick={deselectAll} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Снять все
              </button>
            </Box>
            <TextField
              size="small"
              placeholder="Поиск"
              fullWidth
              autoFocus
              value={searchQuery}
              id="search-input-regions"
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-regions").focus(), 100);
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {filteredRegions.map(([id, name]) => (
            <MenuItem key={id} value={id} onClick={() => toggleRegion(id)}>
              <Checkbox checked={selectedRegions.includes(id)} style={{ pointerEvents: "none", marginRight: "8px" }} />
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};


const CitiesTreeSelect = ({ defaultValue, handleChange, campaign_id, field = "ssp_geo_cities" }) => {
  const [selectedCities, setSelectedCities] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (defaultValue) {
      setSelectedCities(
        defaultValue
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s)
      );
    }
  }, [defaultValue]);

  const allCitiesList = useMemo(() => {
    const list = [];
    Object.values(citiesByRegions).forEach((regionObj) => {
      Object.values(regionObj).forEach((cities) => {
        list.push(...cities);
      });
    });
    return list;
  }, []);

  const commit = useCallback((values) => {
    setSelectedCities(values);
    handleChange(field, values.join(","), campaign_id);
  }, [field, handleChange, campaign_id]);

  const toggleCity = useCallback((city) => {
    setSelectedCities((prev) => {
      const exists = prev.includes(city);
      const next = exists ? prev.filter((c) => c !== city) : [...prev, city];
      handleChange(field, next.join(","), campaign_id);
      return next;
    });
  }, [field, handleChange, campaign_id]);

  const handleRemoveCity = useCallback((city) => {
    setSelectedCities((prev) => {
      const next = prev.filter((c) => c !== city);
      handleChange(field, next.join(","), campaign_id);
      return next;
    });
  }, [field, handleChange, campaign_id]);

  const regionCitiesSelectedState = (cities) => {
    const total = cities.length;
    const selected = cities.filter((c) => selectedCities.includes(c)).length;
    return { total, selected, all: selected === total && total > 0, none: selected === 0, some: selected > 0 && selected < total };
  };

  const toggleRegion = useCallback((cities) => {
    const { all } = regionCitiesSelectedState(cities);
    if (all) {
      const remaining = selectedCities.filter((c) => !cities.includes(c));
      commit(remaining);
    } else {
      const setAll = Array.from(new Set([...selectedCities, ...cities]));
      commit(setAll);
    }
  }, [selectedCities, commit]);

  const selectAllGlobal = useCallback(() => {
    commit(allCitiesList);
  }, [commit, allCitiesList]);

  const deselectAllGlobal = useCallback(() => {
    commit([]);
  }, [commit]);

  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return citiesByRegions;
    const result = {};
    Object.entries(citiesByRegions).forEach(([fo, regionObj]) => {
      const foMatch = fo.toLowerCase().includes(q);
      Object.entries(regionObj).forEach(([regionName, cities]) => {
        const regionMatch = regionName.toLowerCase().includes(q);
        const matchedCities = foMatch || regionMatch
          ? cities
          : cities.filter((city) => city.toLowerCase().includes(q));
        if (matchedCities.length > 0) {
          if (!result[fo]) result[fo] = {};
          result[fo][regionName] = matchedCities;
        }
      });
    });
    return result;
  }, [searchQuery]);

  const renderGrouped = () => {
    return Object.entries(filtered).map(([fo, regionObj]) => (
      <div key={fo}>
        <ListSubheader disableSticky>{fo}</ListSubheader>
        {Object.entries(regionObj).map(([regionName, cities]) => {
          const state = regionCitiesSelectedState(cities);
          return (
            <div key={regionName}>
              <ListSubheader disableSticky>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span>{regionName}</span>
                  <Button size="small" onClick={() => toggleRegion(cities)}>
                    {state.all ? "Снять" : "Выбрать все"}
                  </Button>
                </Box>
              </ListSubheader>
              {cities.map((city) => (
                <MenuItem key={regionName + "_" + city} value={city} onClick={() => toggleCity(city)}>
                  <Checkbox checked={selectedCities.includes(city)} style={{ pointerEvents: "none", marginRight: "8px" }} />
                  {city}
                </MenuItem>
              ))}
            </div>
          );
        })}
      </div>
    ));
  };

  // поиск теперь фильтрует текущую иерархию, отдельный список не используется

  return (
    <Box sx={{ width: 230, padding: "10px 0", textAlign: "start" }}>
      <FormControl fullWidth size="small">
        <InputLabel>Выбор городов</InputLabel>
        <Select
          multiple
          value={selectedCities}
          renderValue={(selected) => selected.join(", ")}
          style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
          sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
          onOpen={() => setTimeout(() => document.getElementById("search-input-cities").focus(), 100)}
          onClose={() => setTimeout(() => setSearchQuery(""), 100)}
          MenuProps={{ autoFocus: false, MenuListProps: { autoFocusItem: false } }}
        >
          <ListSubheader>
            <Box sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mb: 1,
              maxWidth: "500px",
              maxHeight: "300px",
              overflowY: "auto",
              "&::-webkit-scrollbar": { display: "none" },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none"
            }}>
              {selectedCities.slice(0, 20).map((city) => (
                <Chip
                  key={city}
                  label={city}
                  onDelete={() => handleRemoveCity(city)}
                  style={{ border: "2px solid #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                />
              ))}
              {selectedCities.length > 20 && (
                <Chip
                  key="more"
                  label={"+" + (selectedCities.length - 20)}
                  style={{ border: "2px dashed #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                />
              )}
            </Box>
            <Box sx={{ display: "flex", gap: 5, mb: 1 }}>
              <button onClick={selectAllGlobal} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Выбрать все
              </button>
              <button onClick={deselectAllGlobal} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Снять все
              </button>
            </Box>
            <TextField
              size="small"
              placeholder="Поиск города/региона/ФО"
              fullWidth
              autoFocus
              value={searchQuery}
              id="search-input-cities"
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-cities").focus(), 100);
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {renderGrouped()}
        </Select>
      </FormControl>
    </Box>
  );
};



const CampaignData = ({ data }) => {
  const { enqueueSnackbar } = useSnackbar();
  const listCampaigns = []
  listCampaigns.push(data)

  const columns = [
    {
      Header: "ID РК",
      accessor: "id",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Название",
      accessor: "name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Сайт",
      accessor: "site",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Почта клиента",
      accessor: "campaign_creator_email",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Дата создания",
      accessor: "created_at",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Тип РК",
      accessor: "type",
      maxWidth: 400,
      minWidth: 60,
      width: 117,
    },
    {
      Header: "Дневной бюджет",
      accessor: "daily_budget",
      maxWidth: 400,
      minWidth: 80,
      width: 145,
    },
    {
      Header: "Общий бюджет",
      accessor: "full_budget",
      maxWidth: 400,
      minWidth: 80,
      width: 145,
    },
    {
      Header: "Ставка",
      accessor: "bet",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Период с-по",
      accessor: "range",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Сумма спис",
      accessor: "charge",
      maxWidth: 400,
      minWidth: 50,
      width: 150,
    },
    {
      Header: "Статус",
      accessor: "status",
      maxWidth: 400,
      minWidth: 50,
      width: 200,
    },
  ];

  const STATUS_TYPE = {
    ACTIVE: "На модерации",
    INACTIVE: "Неактивна",
    WORK: "Работает",
    MODERATION: "На модерации",
    ERROR: "Ошибка",
  };

  const TARGET_TYPE = {
    TRAFFIC: "Трафик",
    REACH: "Охват",
  };

  function getTableData() {
    return listCampaigns.map((el) => {
      return {
        id: (
          <div
            className="td"
            style={{ display: "flex", flexDirection: "row", borderRadius: 5 }}
          >
            {el.id.slice(0, 8)}
            <ContentCopy
              style={{ marginLeft: 5, cursor: "pointer" }}
              onClick={() => {
                navigator.clipboard.writeText(el.id);
                enqueueSnackbar("ID кампании скопирован", {
                  variant: "success",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
              }}
              className="copyIcon"
              fontSize="small"
            />
          </div>
        ),
        name: <div className="td">{el.name ? el.name : "-"}</div>,
        site: (
          <div className="td" style={{ display: "flex", flexDirection: "row" }}>
            <span>{el.site ? el.site : "-"}</span>
            {el.site && (
              <ContentCopy
                style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(el.site);
                  enqueueSnackbar("Сайт кампании скопирован", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            )}
          </div>
        ),
        campaign_creator_email: (
          <div className="td" style={{ display: "flex", flexDirection: "row" }}>
            <span>{el.campaign_creator_email ? el.campaign_creator_email : "-"}</span>
            {el.campaign_creator_email && (
              <ContentCopy
                style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(el.campaign_creator_email);
                  enqueueSnackbar("Почта клиента скопирована", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            )}
          </div>
        ),
        created_at: (
          <div className="td">
            {dateFormat(Date.parse(el.created_at), "dd/MM/yyyy")}
          </div>
        ),
        type: <div className="td">{TARGET_TYPE[el.target_type]}</div>,
        daily_budget: <div className="td">{el.daily_budget}</div>,
        full_budget: <div className="td">{el.full_budget}</div>,
        bet: <div className="td">{el.price_per_action}</div>,
        range: (
          <div className="td">
            {dateFormat(
              Date.parse(new Date(el.validity_period.date_start)),
              "dd/MM/yyyy"
            )}
            -
            {dateFormat(
              Date.parse(new Date(el.validity_period.date_end)),
              "dd/MM/yyyy"
            )}
          </div>
        ),
        charge: <div className="td">{el.charges_sum}</div>,
        status: (
          <div className="td">
            {STATUS_TYPE[el.status]}
          </div>
        ),
      };
    });
  }

  return (
    <DataTable data={getTableData()} columns={columns} />
  )
}


const getMoscowMidnight = (date) => {
  const targetDate = new Date(date);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');

  const moscowMidnight = new Date(`${year}-${month}-${day}T00:00:00+03:00`);

  return Math.floor(moscowMidnight.getTime() / 1000);
};

const addOneDay = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};

const PostViewData = ({ campaignData }) => {
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [dataList, setDataList] = useState([]);
  const [upd, setUpd] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [goalsList, setGoalsList] = useState([]);
  const [searchGoals, setSearchGoals] = useState('');
  const [selectedGoal, setSelectedGoal] = useState("all");

  const [currentPage, setCurrentPage] = useState(1);
  const [dateType, setDateType] = useState("views");
  const [totalPages, setTotalPages] = useState(1);
  const [pvData, setPvData] = useState({
    pv: 0,
    pv_fake: 0
  });

  const [addPostView, setAddPostView] = useState(0);

  const [conversionsData, setConversionsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/get-goals?campaign_id=${campaignData.id}`, {
        method: "GET",
        headers: myHeaders
      });
      const data = await response.json();
      setGoalsList(data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const _startDate = typeof filtersValue.date.date0 === "number" ? new Date(filtersValue.date.date0) : filtersValue.date.date0
      const _endDate = typeof filtersValue.date.date1 === "number" ? new Date(filtersValue.date.date1) : filtersValue.date.date1

      const date0 = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth() + 1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
      const date1 = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth() + 1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/get-amount-conversions?campaign_id=${campaignData.id}&goal_id=${selectedGoal}&date_from=${date0}&date_to=${date1}`, {
        method: "GET",
        headers: myHeaders
      });
      const data = await response.json();
      setConversionsData(data);
      setIsLoading(false);
    }
    if (selectedGoal !== "all" && filtersValue.date.date0 && filtersValue.date.date1) {
      setIsLoading(true);
      fetchData();
    }
  }, [upd])

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      console.log(filtersValue.date);

      const _startDate = typeof filtersValue.date.date0 === "number" ? new Date(filtersValue.date.date0) : filtersValue.date.date0
      const _endDate = typeof filtersValue.date.date1 === "number" ? new Date(filtersValue.date.date1) : filtersValue.date.date1

      const date0 = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth() + 1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
      const date1 = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth() + 1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

      console.log(date0, date1);
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/get-post-views?campaign_id=${campaignData.id}&date_type=${dateType}&page=${currentPage}&limit=10`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          goal_id: selectedGoal !== "all" ? selectedGoal : undefined,
          date0: date0,
          date1: date1,
        })
      });

      if (response.ok) {
        const data = await response.json();
        setDataList(data.data);
        setTotalPages(data.total_pages);
        setPvData({
          pv: data.amount_of_postviews,
          pv_fake: data.amount_of_fake_postviews
        })
      }
    }
    if (filtersValue.date && Object.values(filtersValue.date).some(date => date !== "")) {
      fetchData();
    }
  }, [upd, currentPage]);

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const columns = [
    {
      Header: "",
      accessor: "is_fake",
      maxWidth: 400,
      minWidth: 80,
      width: 50,
      isSticky: true,
    },
    {
      Header: "ID Конверсии",
      accessor: "conversionId",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Название конверсии",
      accessor: "conversionType",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
      isSticky: true,
    },
    {
      Header: "Дата конверсии",
      accessor: "activityDateTime",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Дата визита",
      accessor: "visitDateTime",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Дата показа",
      accessor: "interactionDateTime",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "ID Кампании",
      accessor: "campaignId",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Название кампании",
      accessor: "campaignName",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Статус события показ/клик",
      accessor: "eventType",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "ID Баннера",
      accessor: "bannerId",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Трекинг система",
      accessor: "trackingSystem",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Домен показа",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "ОС",
      accessor: "OS",
      maxWidth: 400,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "Устройство",
      accessor: "device",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "География",
      accessor: "region",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Браузер",
      accessor: "browser",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Programmatic ID",
      accessor: "programmaticId",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "clientID YM",
      accessor: "clientId",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "IP",
      accessor: "remote_address",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "",
      accessor: "delete",
      maxWidth: 400,
      minWidth: 50,
      width: 50,
      isStickyRight: true,
    },
  ];

  const handleDelete = (post_view_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/minus?post_view_id=${post_view_id}`, {
      method: "GET",
      headers: myHeaders,
    }).then((response) => {
      if (response.ok) {
        setUpd(!upd);
        enqueueSnackbar("Post-View успешно удалена", {
          variant: "success",
          autoHideDuration: 1000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    });
  }

  const handleDateChange = (value, type) => {
    setValue((prev) => ({
      ...prev,
      date: type === 1
        ? { ...prev.date, date0: value[0] ?? "", date1: value[1] ?? "" }
        : { ...prev.date, date2: value[0] ?? "", date3: value[1] ?? "" },
    }));
  };

  const formatDateTime = (date, istext = false) => {
    if (!date) return;
    const d = new Date(date);
    if (isNaN(d.getTime())) return;

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    if (istext) {
      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  function getTableData(data) {
    if (Object.keys(data).length === 0) {
      return [
        {
          is_fake: <div className="td"><span style={{ backgroundColor: "#a4bac7", width: 10, height: 10, display: "inline-block", borderRadius: "50%" }} /></div>,
          conversionId: <div className="td">-</div>,
          conversionType: <div className="td">-</div>,
          activityDateTime: <div className="td">-</div>,
          visitDateTime: <div className="td">-</div>,
          interactionDateTime: <div className="td">-</div>,
          campaignId: <div className="td">-</div>,
          campaignName: <div className="td">-</div>,
          eventType: <div className="td">-</div>,
          bannerId: <div className="td">-</div>,
          trackingSystem: <div className="td">-</div>,
          domain: <div className="td">-</div>,
          OS: <div className="td">-</div>,
          device: <div className="td">-</div>,
          region: <div className="td">-</div>,
          browser: <div className="td">-</div>,
          programmaticId: <div className="td">-</div>,
          clientId: <div className="td">-</div>,
          remote_address: <div className="td">-</div>,
          delete: <div className="td"></div>,
        },
      ];
    }

    return data
      .sort((a, b) => (a.conversion_datetime > b.conversion_datetime ? -1 : 1))
      .map((row) => {
        return {
          is_fake: <div className="td"><span style={{ backgroundColor: row.is_fake ? "#f7b807" : "#05d005", width: 10, height: 10, display: "inline-block", borderRadius: "50%" }} /></div>,
          conversionId: <div className="td">{row.conversion_id || "-"}</div>,
          conversionType: <div className="td">{row.conversion_type || "-"}</div>,
          activityDateTime: <div className="td">{formatDateTime(row.conversion_datetime, true) || "-"}</div>,
          visitDateTime: <div className="td">{formatDateTime(row.last_visit_before_conversion, true) || "-"}</div>,
          interactionDateTime: <div className="td">{formatDateTime(row.view_datetime, true) || "-"}</div>,
          campaignId: <div className="td">{row.campaign_id || "-"}</div>,
          campaignName: <div className="td">{row.campaign_name || "-"}</div>,
          eventType: <div className="td">{row.event_type || "-"}</div>,
          bannerId: <div className="td">{row.banner_id || "-"}</div>,
          trackingSystem: <div className="td">{row.tracking_system || "-"}</div>,
          domain: <div className="td">{row.domain || "-"}</div>,
          OS: <div className="td">{row.os || "-"}</div>,
          device: <div className="td">{row.device || "-"}</div>,
          region: <div className="td">{row.region || "-"}</div>,
          browser: <div className="td">{row.browser || "-"}</div>,
          programmaticId: <div className="td">{row.programmatic_id || "-"}</div>,
          clientId: <div className="td">{row.client_id || "-"}</div>,
          remote_address: <div className="td">{row.remote_address || "-"}</div>,
          delete: row.is_fake ? (
            <div
              className="td ban"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <svg
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  const answer = await confirm("Вы подтверждаете удаление Post-View ?")
                  if (!answer) return;
                  handleDelete(row.id)
                }}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.3327 0.666016L0.666016 11.3327M11.3327 11.3327L0.666016 0.666016L11.3327 11.3327Z"
                  stroke="#42454C"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          ) : (
            <div className="td"></div>
          )
        };
      });
  }

  const filteredGoalsList = goalsList.filter((goal) =>
    goal.name?.toLowerCase().includes(searchGoals.toLowerCase())
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <Box sx={{ width: "fit-content", minWidth: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
          <FormControl fullWidth size="small">
            <InputLabel
              id="demo-select-small-label"
              sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
            >
              Выбор цели
            </InputLabel>
            <Select
              onOpen={() => setTimeout(() => document.getElementById("search-input-goals").focus(), 100)}
              value={selectedGoal || "all"}
              onChange={(e) => setSelectedGoal(e.target.value)}
              style={{
                height: 32,
                margin: "0",
                padding: "0",
                background: "#FFFFFF",
                borderColor: "transparent",
              }}
              sx={{
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
              label="CallTracking"
              id="demo-select-small"
              onClose={() => setTimeout(() => setSearchGoals(""), 300)}
              renderValue={(value) => {
                if (value === "all") return "Все цели";
                const goal = goalsList.find((g) => g._id === value);
                return goal ? `${goal.name} - ${goal._id}` : value;
              }}
            >
              <ListSubheader>
                <TextField
                  id="search-input-goals"
                  size="small"
                  autoFocus
                  placeholder="Поиск"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchGoals(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      setTimeout(() => document.getElementById("search-input-goals").focus(), 100)
                    }
                    if (e.key !== "Escape") {
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              <MenuItem value="all">Все цели</MenuItem>
              {filteredGoalsList.map((goal) => (
                <MenuItem key={goal._id} value={goal._id}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1 }}>
                    <span>
                      {goal.name} - {goal._id}
                    </span>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                          navigator.clipboard.writeText(goal._id).then(() => {
                            enqueueSnackbar && enqueueSnackbar("ID цели скопирован", { variant: "success" });
                          });
                        }
                      }}
                      edge="end"
                      aria-label="copy-goal-id"
                    >
                      <ContentCopy fontSize="inherit" />
                    </IconButton>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {
          conversionsData.used !== undefined && (
            <div>
              <button
                style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
                onClick={async () => {
                  const answer = await confirm("Вы подтверждаете добавление Post-View ?")
                  if (!answer) return;
                  const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  myHeaders.append(
                    "Authorization",
                    "Bearer " + localStorage.getItem("admin_token")
                  );

                  if (selectedGoal === "all") {
                    return enqueueSnackbar("Выберите определенную цель", {
                      variant: "info",
                      autoHideDuration: 2000,
                      anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                  }
                  const date0 = getMoscowMidnight(new Date(filtersValue.date.date0));
                  const date1 = getMoscowMidnight(new Date(new Date(filtersValue.date.date1).setDate(new Date(filtersValue.date.date1).getDate() + 1)));

                  const response = await fetch(
                    `${DOMAIN_API_HOST}/api/v1/admin/plus?campaign_id=${campaignData.id}&date_from=${date0}&date_to=${date1}${selectedGoal !== "all" ? `&goal_id=${selectedGoal}` : ""}`,
                    {
                      method: "GET",
                      headers: myHeaders,
                    }
                  );

                  if (response.ok) {
                    setUpd(!upd);
                    enqueueSnackbar("Доп. Post-View по цели успешно добавлена.", {
                      variant: "success",
                      autoHideDuration: 2000,
                      anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                  } else {
                    enqueueSnackbar("Ошибка в добавлении доп. Post-View", {
                      variant: "error",
                      autoHideDuration: 2000,
                      anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                  }
                }}
              >
                +1 доп. Post-view
              </button>
            </div>
          )
        }
      </div>

      {
        conversionsData.used !== undefined && (
          <div style={{ padding: "0 13px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, borderRadius: 10 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontSize: 12, opacity: "70%", marginBottom: 5 }}>
                  Добавление Post-View
                </p>
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <input style={{ width: "250px", fontSize: 14, padding: "3px 15px", borderRadius: 5, border: "1px solid #dfe8ff" }} onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    setAddPostView(e.target.value)
                  }} placeholder="Количество Post-View"></input>
                  <button
                    style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
                    onClick={async () => {
                      const answer = await confirm("Вы подтверждаете добавление Post-View ?")
                      if (!answer) return;
                      const myHeaders = new Headers();
                      myHeaders.append("Content-Type", "application/json");
                      myHeaders.append(
                        "Authorization",
                        "Bearer " + localStorage.getItem("admin_token")
                      );

                      if (selectedGoal === "all", !addPostView, addPostView <= 0) {
                        return enqueueSnackbar("Выберите определенную цель и введите количество Post-View", {
                          variant: "info",
                          autoHideDuration: 2000,
                          anchorOrigin: { vertical: "top", horizontal: "right" },
                        });
                      }
                      if (addPostView > 1000) {
                        return enqueueSnackbar("Количество Post-View не должно превышать 1000", {
                          variant: "info",
                          autoHideDuration: 2000,
                          anchorOrigin: { vertical: "top", horizontal: "right" },
                        });
                      }

                      const date0 = getMoscowMidnight(new Date(filtersValue.date.date0));
                      const date1 = getMoscowMidnight(new Date(new Date(filtersValue.date.date1).setDate(new Date(filtersValue.date.date1).getDate() + 1)));

                      const response = await fetch(
                        `${DOMAIN_API_HOST}/api/v1/admin/make-postviews?amount=${addPostView}&campaign_id=${campaignData.id}&date_from=${date0}&date_to=${date1}${selectedGoal !== "all" ? `&goal_id=${selectedGoal}` : ""}`,
                        {
                          method: "POST",
                          headers: myHeaders,
                        }
                      );
                      if (response.ok) {
                        enqueueSnackbar(`Запрос на добавление ${addPostView} Post-View успешно отправлен.`, {
                          variant: "success",
                          autoHideDuration: 2500,
                          anchorOrigin: { vertical: "top", horizontal: "right" },
                        });
                      }
                    }}
                  >
                    Добавить
                  </button>
                </div>
                <div>
                  {isLoading ? (
                    <p style={{ fontSize: 13, opacity: "70%", marginTop: 10 }}>
                      Загрузка данных...
                    </p>
                  ) : (
                    <div style={{ display: "flex", gap: 15 }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 5, marginTop: 10 }}>
                        <p style={{ fontSize: 12, opacity: "70%" }}>
                          Конверсий используется с DMP
                        </p>
                        <p style={{ fontSize: 13, opacity: "70%" }}>
                          {conversionsData.used} из {conversionsData.used + conversionsData.unused}
                        </p>
                      </div>
                      <div style={{ width: 2, height: 35, backgroundColor: "#e4e4e4", marginTop: 10 }}></div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 5, marginTop: 10 }}>
                        <p style={{ fontSize: 12, opacity: "70%" }}>
                          Показов за выбранный период
                        </p>
                        <p style={{ fontSize: 13, opacity: "70%" }}>
                          {conversionsData.views.toLocaleString("ru-RU")}
                        </p>
                      </div>
                      <div>
                        <button
                          style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5, marginTop: 10 }}
                          onClick={async () => {
                            const myHeaders = new Headers();
                            myHeaders.append("Content-Type", "application/json");
                            myHeaders.append(
                              "Authorization",
                              "Bearer " + localStorage.getItem("admin_token")
                            );

                            if (selectedGoal === "all") {
                              return enqueueSnackbar("Выберите определенную цель", {
                                variant: "info",
                                autoHideDuration: 2000,
                                anchorOrigin: { vertical: "top", horizontal: "right" },
                              });
                            }

                            const toYMD = (dateValue) => {
                              const dateObj = typeof dateValue === "number" ? new Date(dateValue) : new Date(dateValue);
                              const yyyy = dateObj.getFullYear();
                              const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
                              const dd = String(dateObj.getDate()).padStart(2, "0");
                              return `${yyyy}-${mm}-${dd}`;
                            };

                            const extractDomain = (site) => {
                              try {
                                const url = site?.startsWith("http") ? new URL(site) : new URL(`https://${site}`);
                                return url.hostname;
                              } catch (e) {
                                return String(site || "").replace(/^https?:\/\//, "").split("/")[0];
                              }
                            };

                            const date_from = toYMD(filtersValue.date.date0);
                            const date_to = toYMD(filtersValue.date.date1);
                            const siteDomain = extractDomain(campaignData.site);

                            const response = await fetch(
                              `https://api.programmatic.ru/api/v1/admin/add-conversions?campaign_id=${siteDomain}&date_from=${date_from}&date_to=${date_to}&goal_id=${selectedGoal}`,
                              {
                                method: "GET",
                                headers: myHeaders,
                              }
                            );

                            if (response.ok) {
                              enqueueSnackbar(`Запрос на добавление конверсий успешно отправлен. Обновите таблицу через минуту.`, {
                                variant: "success",
                                autoHideDuration: 2500,
                                anchorOrigin: { vertical: "top", horizontal: "right" },
                              });
                            }
                          }}
                        >
                          Сбор конверсий
                        </button>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        )
      }


      <div style={{ width: "350px" }}>
        <div>
          <Box sx={{ width: 175, margin: "10px 0" }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Промежуток времени
              </InputLabel>
              <Select
                style={{
                  height: 32,
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="Промежуток времени"
                id="demo-select-small-label"
                defaultValue={"views"}
                onChange={(e) => {
                  console.log(e.target.value);
                  setCurrentPage(1);
                  setDateType(e.target.value);
                  setUpd(!upd);
                }}
              >
                <MenuItem value={"views"}>По показам</MenuItem>
                <MenuItem value={"conversions"}>По конверсиям</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>

        <DateFromTo
          from={new Date(new Date().setHours(0, 0, 0, 0) - 1 * 24 * 60 * 60 * 1000).getTime()}
          to={new Date(new Date().setHours(23, 59, 59, 999)).getTime()}
          handleChange={(value) => handleDateChange(value, 1)}
        />
      </div>

      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <h3 style={{ fontSize: 18 }}>Таблица</h3>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
              onClick={() => {
                setUpd((prev) => !prev);
                enqueueSnackbar("Запрос на обновление таблицы.", {
                  variant: "success",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
              }}
            >
              Обновить
            </button>
            <button
              style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
              onClick={async () => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append(
                  "Authorization",
                  "Bearer " + localStorage.getItem("admin_token")
                );

                const _startDate = typeof filtersValue.date.date0 === "number" ? new Date(filtersValue.date.date0) : filtersValue.date.date0
                const _endDate = typeof filtersValue.date.date1 === "number" ? new Date(filtersValue.date.date1) : filtersValue.date.date1

                const date_start = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth() + 1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
                const date_end = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth() + 1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

                const response = await fetch(
                  `${DOMAIN_API_HOST}/api/v1/admin/post-views/export/${campaignData.id}?date_from=${date_start}&date_to=${date_end}&extra=true${selectedGoal !== "all" ? `&goal_id=${selectedGoal}` : ""}`,
                  {
                    method: "GET",
                    headers: myHeaders,
                  }
                );

                if (response.ok) {
                  const blob = await response.blob();
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;

                  link.download = `post_view_report_${campaignData.name}.xlsx`;
                  document.body.appendChild(link);
                  link.click();

                  link.remove();
                  window.URL.revokeObjectURL(url);
                } else {
                  console.error("Ошибка при скачивании файла:", response.statusText);
                }
              }}
            >
              Скачать
            </button>
          </div>
        </div>

        {
          dataList.length > 0 ? (
            <div>
              <div style={{ display: "flex", gap: "15px", alignItems: "center", fontSize: 14, opacity: 0.8, fontWeight: 600, marginTop: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ backgroundColor: "gray", width: "6px", height: "6px", borderRadius: "50%", display: "inline-block" }}></span>
                  <p>Всего {pvData.pv + pvData.pv_fake}</p>
                </div>
                |
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ backgroundColor: "#05d005", width: "6px", height: "6px", borderRadius: "50%", display: "inline-block" }}></span>
                  <p>PV {pvData.pv}</p>
                </div>
                |
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ backgroundColor: "#f7b807", width: "6px", height: "6px", borderRadius: "50%", display: "inline-block" }}></span>
                  <p><p>PV+ {pvData.pv_fake}</p></p>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "25px", overflowX: "auto", scrollbarWidth: "none", '-ms-overflow-style': 'none' }}>
                <DataTable data={getTableData(dataList)} columns={columns} />
              </div>
            </div>
          ) : (
            <div style={{ width: "900px", display: "flex", height: "25px", justifyContent: "center", alignItems: "center" }}>
              Данные не найдены.
            </div>
          )
        }
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, marginTop: 20 }}>
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
            onClick={() => handlePageChange("prev")}
            disabled={currentPage === 1}
          >
            {"Назад"}
          </button>
          <h4 style={{ letterSpacing: 1.5 }}>
            {currentPage} / {totalPages}
          </h4>
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
            onClick={() => handlePageChange("next")}
            disabled={currentPage === totalPages}
          >
            {"Дальше"}
          </button>
        </Box>
      </div>
    </div>
  );
};



const DatePickerTest = ({ defaultValue, value, onChange }) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue || '');

  useEffect(() => {
    const isTimestamp = (input) =>
      typeof input === 'number' || /^\d{10,}$/.test(String(input));

    if (value !== undefined && value !== null) {
      setSelectedDate(isTimestamp(value) ? formatDatePicker(value) : value);
    } else if (defaultValue) {
      setSelectedDate(isTimestamp(defaultValue) ? formatDatePicker(defaultValue) : defaultValue);
    }
  }, [value, defaultValue]);

  const handleDateChange = (e) => {
    const newDate = e.target.value;

    if (value === undefined || value === null) {
      setSelectedDate(newDate);
    }

    if (onChange) {
      onChange(newDate);
    }
  };

  return (
    <div style={stylesDatePicker.datepickerContainer}>
      <input
        type="date"
        value={selectedDate}
        onChange={handleDateChange}
        style={stylesDatePicker.datepickerInput}
      />
    </div>
  );
};



const formatDatePicker = (date, istext = false) => {
  if (date === 0 || !date) return;
  const d = new Date(date * 1000);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  if (istext) return `${day}.${month}.${year}`
  return `${year}-${month}-${day}`;
};

const stylesDatePicker = {
  datepickerContainer: {
    padding: "5px 0 0 0",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  datepickerInput: {
    padding: '8px',
    fontSize: '14px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    ':hover': {
      borderColor: '#888',
    },
    ':focus': {
      borderColor: '#007bff',
    },
  },
};


const BannersStatsData = ({ campaignData }) => {
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [filterArr, setFilter] = useState([]);
  const [upd, setUpd] = useState(false);
  const [tableType, setTableType] = useState("finance");

  const [partners, setPartners] = useState([]);
  const [partner, setPartner] = useState("all");

  const [ads, setAds] = useState([]);
  const [ad, setAd] = useState("all");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const abortControllerRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      const abortController = new AbortController();
      abortControllerRef.current = abortController;

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );

      const _startDate = typeof filtersValue.date.date_start === "number" ? new Date(filtersValue.date.date_start) : filtersValue.date.date_start
      const _endDate = typeof filtersValue.date.date_end === "number" ? new Date(filtersValue.date.date_end) : filtersValue.date.date_end

      const date_start = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth() + 1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
      const date_end = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth() + 1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

      try {
        switch (tableType) {
          case "details": {
            let queryParams = `campaign_id=${campaignData.id}&target_type=REACH&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&limit=10&report_type=internal`;

            if (partner !== "all") {
              queryParams += `&partner_name=${partner}`;
            }
            if (ad !== "all") {
              queryParams += `&advert_id=${ad}`;
            }
            const detailResponse = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/details?${queryParams}`, {
              method: "GET",
              headers: myHeaders,
              signal: abortController.signal,
            });
            if (detailResponse.ok) {
              const data = await detailResponse.json();
              if (!abortController.signal.aborted) {
                setFilter(data.data);
                setTotalPages(data.total_pages);
              }
            }
            break;
          }
          case "domain": {
            let queryParams = `campaign_id=${campaignData.id}&target_type=REACH&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&limit=10&report_type=internal`;

            if (partner !== "all") {
              queryParams += `&partner_name=${partner}`;
            }
            if (ad !== "all") {
              queryParams += `&advert_id=${ad}`;
            }
            const domainResponse = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_domain?${queryParams}`, {
              method: "GET",
              headers: myHeaders,
              signal: abortController.signal,
            });
            if (domainResponse.ok) {
              const data = await domainResponse.json();
              if (!abortController.signal.aborted) {
                setFilter(data.data);
                setTotalPages(data.total_pages);
              }
            }
            break;
          }
          case "finance": {
            let queryParams = `campaign_id=${campaignData.id}&target_type=REACH&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&limit=10&report_type=internal`;

            if (partner !== "all") {
              queryParams += `&partner_name=${partner}`;
            }
            if (ad !== "all") {
              queryParams += `&advert_id=${ad}`;
            }
            const response = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_finance?${queryParams}`, {
              method: "GET",
              headers: myHeaders,
              signal: abortController.signal,
            });
            if (response.ok) {
              const data = await response.json();
              if (!abortController.signal.aborted) {
                setFilter(data.data);
                setTotalPages(data.total_pages);
              }
            }
            break;
          }
          case "geo": {
            let queryParams = `campaign_id=${campaignData.id}&target_type=REACH&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&limit=10&report_type=internal`;

            if (partner !== "all") {
              queryParams += `&partner_name=${partner}`;
            }
            if (ad !== "all") {
              queryParams += `&advert_id=${ad}`;
            }
            const geoResponse = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_geo?${queryParams}`, {
              method: "GET",
              headers: myHeaders,
              signal: abortController.signal,
            });
            if (geoResponse.ok) {
              const data = await geoResponse.json();
              if (!abortController.signal.aborted) {
                setFilter(data.data);
                setTotalPages(data.total_pages);
              }
            }
            break;
          }
          default:
            break;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Ошибка загрузки данных:', error);
        }
      }
    }

    if (filtersValue.date.date_start && filtersValue.date.date_end) {
      fetchData();
    }
    console.log(tableType)

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [filtersValue.date.date_start, filtersValue.date.date_end, upd, tableType, currentPage, partner, ad]);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const partnerResponse = await fetch(
        `${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch`,
        {
          method: "GET",
          headers: myHeaders,
        }
      );
      if (partnerResponse.ok) {
        const data = await partnerResponse.json();
        setPartners(data);
      }
      const adsResponse = await fetch(
        `${DOMAIN_API_HOST}/api/v1/advertisements/fetch?campaign_id=${campaignData.id}`,
        {
          method: "GET",
          headers: myHeaders,
        }
      );
      if (adsResponse.ok) {
        const data = await adsResponse.json();
        setAds(data);
      }
    }
    fetchData();
  }, []);

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const detailColumns = [
    {
      Header: "Дата и время",
      accessor: "created_at",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "IP",
      accessor: "remote_address",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Сайт",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Гео",
      accessor: "geo",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    // {
    //   Header: "CPM ставка",
    //   accessor: "cost",
    //   maxWidth: 400,
    //   minWidth: 80,
    //   width: 150,
    // },
  ];

  function detailGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB - dateA;
    });

    return sortedData.map((el) => {
      return {
        created_at: <div className="td">{el.created_at ? dateFormat(new Date(el.created_at), "dd.MM.yyyy HH:mm:ss") : "-"}</div>,
        remote_address: <div className="td">{el.remote_address ? el.remote_address : "-"}</div>,
        domain: <div className="td">{el.domain ? el.domain : "Нет"}</div>,
        geo: <div className="td">{regionsData[el.geo] || el.geo || "Нет"}</div>,
        // cost: <div className="td">{el.cost ? el.cost + " руб." : "-"}</div>,
      };
    });
  }

  const geoColumns = [
    {
      Header: "Гео",
      accessor: "geo",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Показы",
      accessor: "impressions",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Просмотры",
      accessor: "clicks",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "CTR",
      accessor: "ctr",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];

  function geoGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });

    return sortedData.map((el) => {
      return {
        geo: <div className="td">{regionsData[el.geo] || el.geo || "Нет"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
      };
    });
  }

  const domainColumns = [
    {
      Header: "Сайт",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "ID сайта",
      accessor: "site_id",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Показы",
      accessor: "impressions",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Просмотры",
      accessor: "clicks",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "CTR",
      accessor: "ctr",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "eCPM",
      accessor: "ecpm",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Затраты",
      accessor: "total_cost",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];

  function domainGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });

    return sortedData.map((el) => {
      return {
        domain: <div className="td">{el.domain ? el.domain : "Нет"}</div>,
        site_id: <div className="td">{el.site_id ? el.site_id : "Нет"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
        ecpm: <div className="td">{el.average_cpm ? el.average_cpm : "0"}</div>,
        total_cost: <div className="td">{el.total_cost ? el.total_cost : "0"}</div>,
      };
    });
  }


  const financeColumns = [
    {
      Header: "Дата",
      accessor: "date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Показы",
      accessor: "impressions",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Клики",
      accessor: "clicks",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "CTR",
      accessor: "ctr",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "eCPM",
      accessor: "ecpm",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Затраты",
      accessor: "total_cost",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];

  function financeGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });

    return sortedData.map((el) => {
      return {
        date: <div className="td">{el.date ? dateFormat(new Date(el.date), "dd.MM.yyyy") : "-"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
        ecpm: <div className="td">{el.average_cpm ? el.average_cpm : "0"}</div>,
        total_cost: <div className="td">{el.total_cost ? el.total_cost : "0"}</div>,
      };
    });
  }

  const handleDateChange = (value) => {
    setValue((prev) => ({
      ...prev,
      date: { date_end: value[1] ?? "", date_start: value[0] ?? "" },
    }));
  };



  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: "400px" }}>
          <DateFromTo
            from={new Date(new Date().setHours(0, 0, 0, 0) - 1 * 24 * 60 * 60 * 1000).getTime()}
            to={new Date(new Date().setHours(23, 59, 59, 999)).getTime()}
            handleChange={handleDateChange}
          />
        </div>
        <button
          style={{ marginLeft: 80, width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 20px", fontSize: 14, borderRadius: 5 }}
          onClick={async () => {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
              "Authorization",
              "Bearer " + localStorage.getItem("admin_token")
            );

            const _startDate = typeof filtersValue.date.date_start === "number" ? new Date(filtersValue.date.date_start) : filtersValue.date.date_start
            const _endDate = typeof filtersValue.date.date_end === "number" ? new Date(filtersValue.date.date_end) : filtersValue.date.date_end

            const date_start = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth() + 1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
            const date_end = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth() + 1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

            let queryParams = `campaign_id=${campaignData.id}&date_from=${date_start}&date_to=${date_end}&breakdown_type=${tableType}&report_type=internal`;

            if (partner !== "all") {
              queryParams += `&partner_name=${partner}`;
            }

            if (ad !== "all") {
              queryParams += `&advert_id=${ad}`;
            }

            const response = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/export?${queryParams}`, {
              method: "GET",
              headers: myHeaders,
            });

            if (response.ok) {
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;

              link.download = `${tableType}_statistics_${campaignData.name}.xlsx`;
              document.body.appendChild(link);
              link.click();

              link.remove();
              window.URL.revokeObjectURL(url);
            } else {
              console.error("Ошибка при скачивании файла:", response.statusText);
            }
          }}
        >
          Скачать
        </button>
      </div>
      <div style={{ display: "flex", gap: 20 }}>
        <Box sx={{ width: 175 }}>
          <FormControl fullWidth size="small">
            <InputLabel
              id="demo-select-small-label"
              sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
            >
              Тип отчёта
            </InputLabel>
            <Select
              style={{
                height: 32,
                background: "#FFFFFF",
                borderColor: "transparent",
              }}
              sx={{
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
              label="Партнёр"
              id="demo-select-small-label"
              defaultValue={"finance"}
              onChange={(e) => {
                console.log(e.target.value);
                setTableType(e.target.value);
                setCurrentPage(1);
                setUpd(!upd);
              }}
            >
              <MenuItem value={"details"}>Детальный</MenuItem>
              <MenuItem value={"geo"}>По гео</MenuItem>
              <MenuItem value={"domain"}>По доменам</MenuItem>
              <MenuItem value={"finance"}>По финансам</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ width: 175 }}>
          <FormControl fullWidth size="small">
            <InputLabel
              id="demo-select-small-label"
              sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
            >
              По партнёру
            </InputLabel>
            <Select
              style={{
                height: 32,
                background: "#FFFFFF",
                borderColor: "transparent",
              }}
              sx={{
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
              label="Партнёр"
              id="demo-select-small-label"
              defaultValue={"all"}
              onChange={(e) => {
                console.log(e.target.value);
                setPartner(e.target.value);
                setCurrentPage(1);
                setUpd(!upd);
              }}
            >
              <MenuItem value={"all"}>Все</MenuItem>
              {partners.map((item) => (
                <MenuItem key={item.id} value={item.name}>{item.display_name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ width: 250 }}>
          <FormControl fullWidth size="small">
            <InputLabel
              id="ad-select-label"
              sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
            >
              По объявлению
            </InputLabel>
            <Select
              labelId="ad-select-label"
              id="ad-select"
              value={ad}
              onChange={(e) => {
                setAd(e.target.value);
                setCurrentPage(1);
                setUpd(!upd);
              }}
              displayEmpty
              renderValue={(selected) => {
                if (selected === "all") return "По всем";
                const selectedAd = ads.find((item) => item.id === selected);
                return selectedAd ? selectedAd.head : "Выберите объявление";
              }}
              style={{
                height: 32,
                background: "#FFFFFF",
                borderColor: "transparent",
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
            >
              <MenuItem value={"all"}>
                <div style={{ padding: "10px 0" }}>По всем</div>
              </MenuItem>
              {ads.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <div style={{ display: "flex", gap: 10, maxWidth: 300 }}>
                    {item.banners.length !== 0 && (
                      item.banners[0].extension && item.banners[0].extension.toLowerCase() === "mp4" ? (
                        <video
                          style={{
                            width: "50px",
                            height: "100%",
                            objectFit: "contain",
                          }}
                          src={item.banners[0].url}
                          muted
                          controls
                        />
                      ) : (
                        <img
                          style={{
                            width: "50px",
                            height: "100%",
                            objectFit: "contain",
                          }}
                          src={item.banners[0].url}
                          alt="banner"
                        />
                      )
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p style={{ fontSize: 15, margin: 0 }}>{item.head}</p>
                      <p
                        style={{
                          fontSize: 14,
                          opacity: "80%",
                          maxWidth: 200,
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          margin: 0,
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </div>

      {
        tableType === "details" && (
          detailGetTableData().length > 0 ? (
            <DataTable data={detailGetTableData()} columns={detailColumns} />
          ) : (
            <div>Данные не найдены</div>
          )
        )
      }

      {
        tableType === "geo" && (
          geoGetTableData().length > 0 ? (
            <DataTable data={geoGetTableData()} columns={geoColumns} />
          ) : (
            <div>Данные не найдены</div>
          )
        )
      }

      {
        tableType === "domain" && (
          domainGetTableData().length > 0 ? (
            <DataTable data={domainGetTableData()} columns={domainColumns} />
          ) : (
            <div>Данные не найдены</div>
          )
        )
      }

      {
        tableType === "finance" && (
          financeGetTableData().length > 0 ? (
            <DataTable data={financeGetTableData()} columns={financeColumns} />
          ) : (
            <div>Данные не найдены</div>
          )
        )
      }

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, marginTop: 20 }}>
        <button
          style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 1}
        >
          {"Назад"}
        </button>
        <h4 style={{ letterSpacing: 1.5 }}>
          {currentPage} / {totalPages}
        </h4>
        <button
          style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
          onClick={() => handlePageChange("next")}
          disabled={currentPage === totalPages}
        >
          {"Дальше"}
        </button>
      </Box>
    </div>
  );
};


const GoalPicker = ({ goalsList, fieldName, handleChange, defaultValue, campaignId }) => {
  const [searchGoals, setSearchGoals] = useState('');
  const [selectedGoal, setSelectedGoal] = useState(defaultValue || "nope");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setSelectedGoal(defaultValue || "nope");
  }, [defaultValue]);

  const filteredGoalsList = goalsList.filter((goal) =>
    goal.name?.toLowerCase().includes(searchGoals.toLowerCase())
  );

  return (
    <Box sx={{ width: "100%", textAlign: "start", padding: "2px 0", height: 30, marginTop: 8 }}>
      <FormControl fullWidth size="small">
        <InputLabel
          id="demo-select-small-label"
          sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
        >
          Выбор цели
        </InputLabel>
        <Select
          onOpen={() => setTimeout(() => document.getElementById("search-input-goals").focus(), 100)}
          value={selectedGoal || "nope"}
          onChange={(e) => {
            setSelectedGoal(e.target.value);
            handleChange(fieldName, String(e.target.value), campaignId);
          }}
          style={{
            height: 32,
            margin: "0 10px",
            background: "#FFFFFF",
            borderColor: "transparent",
          }}
          sx={{
            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
          label="CallTracking"
          id="demo-select-small"
          onClose={() => setTimeout(() => setSearchGoals(""), 300)}
          renderValue={(value) => {
            if (value === "nope") return "Не выбрано";
            const goal = goalsList.find((g) => String(g._id) === String(value));
            return goal ? `${goal.name} - ${goal._id}` : value;
          }}
        >
          <ListSubheader>
            <TextField
              id="search-input-goals"
              size="small"
              autoFocus
              placeholder="Поиск"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchGoals(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-goals").focus(), 100)
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          <MenuItem value="nope">Не выбрано</MenuItem>
          {filteredGoalsList.map((goal) => (
            <MenuItem key={goal._id} value={goal._id}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1 }}>
                <span>
                  {goal.name} - {goal._id}
                </span>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                      navigator.clipboard.writeText(goal._id).then(() => {
                        enqueueSnackbar && enqueueSnackbar("ID цели скопирован", { variant: "success" });
                      });
                    }
                  }}
                  edge="end"
                  aria-label="copy-goal-id"
                >
                  <ContentCopy fontSize="inherit" />
                </IconButton>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}


const SettingsPostView = ({ campaignData }) => {
  const [goalsList, setGoalsList] = useState([]);
  const [rows, setRows] = useState(
    Array.isArray(campaignData?.fake_postview_goals)
      ? campaignData.fake_postview_goals.map((g) => ({ id: g.id, percent: g.percent === 0 ? "0" : (g.percent != null ? String(g.percent) : "") }))
      : []
  );

  const debounceTimers = useRef({});
  const updateQueues = useRef({});
  const isUpdating = useRef({});

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/get-goals?campaign_id=${campaignData.id}`, {
        method: "GET",
        headers: myHeaders
      });
      const data = await response.json();
      setGoalsList(data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    setRows(
      Array.isArray(campaignData?.fake_postview_goals)
        ? campaignData.fake_postview_goals.map((g) => ({ id: g.id, percent: g.percent === 0 ? "0" : (g.percent != null ? String(g.percent) : "") }))
        : []
    );
  }, [campaignData?.fake_postview_goals]);

  const debounceUpdate = (field, campaign_id, callback, delay = 500) => {
    const uniqueKey = `${field}-${campaign_id}`;
    clearTimeout(debounceTimers.current[uniqueKey]);

    debounceTimers.current[uniqueKey] = setTimeout(() => {
      if (!updateQueues.current[uniqueKey]) updateQueues.current[uniqueKey] = [];
      updateQueues.current[uniqueKey].push(callback);
      processUpdateQueue(uniqueKey);
    }, delay);
  };

  const processUpdateQueue = async (uniqueKey) => {
    if (isUpdating.current[uniqueKey] || !updateQueues.current[uniqueKey] || updateQueues.current[uniqueKey].length === 0) return;

    isUpdating.current[uniqueKey] = true;

    while (updateQueues.current[uniqueKey].length > 0) {
      const callback = updateQueues.current[uniqueKey].shift();
      await callback();
    }

    isUpdating.current[uniqueKey] = false;
  };

  const updateFields = async (fields, campaign_id) => {
    if (campaign_id === null) return;
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaign_id}/update_ssp`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
      body: JSON.stringify(fields),
    });
  };

  const pushUpdate = (nextRows) => {
    const serialized = (nextRows || [])
      .filter((g) => {
        if (!g || !g.id || g.id === "nope") return false;
        const raw = (g.percent ?? "").toString().trim();
        if (raw === "") return false;
        const normalized = raw.replace(",", ".");
        return /^\d*\.?\d*$/.test(normalized);
      })
      .map((g) => {
        const normalized = (g.percent ?? "").toString().trim().replace(",", ".");
        let val = parseFloat(normalized);
        if (!isFinite(val)) val = 0;
        if (val < 0) val = 0;
        if (val > 100) val = 100;
        return { id: g.id, percent: Number(val.toFixed(4)) };
      });
    debounceUpdate("fake_postview_goals", campaignData.id, async () => {
      await updateFields({ fake_postview_goals: serialized }, campaignData.id);
    });
  };

  const handleAddRow = () => {
    const next = [...rows, { id: "nope", percent: 0 }];
    setRows(next);
    pushUpdate(next);
  };

  const handleDeleteRow = (index) => {
    const next = rows.filter((_, i) => i !== index);
    setRows(next);
    pushUpdate(next);
  };

  const handleRowGoalChange = (index, _fieldName, value) => {
    const next = rows.map((r, i) => (i === index ? { ...r, id: value } : r));
    setRows(next);
    pushUpdate(next);
  };

  const handleRowPercentChange = (index, valueRaw) => {
    const valueStr = String(valueRaw);
    const normalized = valueStr.replace(/,/g, ".");
    if (normalized === "") {
      const next = rows.map((r, i) => (i === index ? { ...r, percent: "" } : r));
      setRows(next);
      return;
    }
    if (!/^\d*\.?\d*$/.test(normalized)) return;
    const next = rows.map((r, i) => (i === index ? { ...r, percent: valueStr } : r));
    setRows(next);
    pushUpdate(next);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 20 }}>
      <div style={{ fontSize: 12, color: "#6b7280" }}>Добавьте одну или несколько целей и укажите процент от конверсий для расчёта PV+.</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {rows.map((row, index) => (
          <div key={`postview-row-${index}`} style={{ display: "flex", alignItems: "center", gap: 12, background: "#fafafa", border: "1px solid #e5e7eb", borderRadius: 8, padding: 10 }}>
            <GoalPicker
              goalsList={goalsList}
              fieldName="id"
              defaultValue={row.id}
              campaignId={campaignData.id}
              handleChange={(fieldName, value) => handleRowGoalChange(index, fieldName, value)}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "flex-end", width: "max-content" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <span style={{ fontSize: 11, color: "#999999", textWrap: "nowrap" }}>Процент от конверсий</span>
                <input
                  value={row.percent ?? ""}
                  onChange={(e) => handleRowPercentChange(index, e.target.value)}
                  type="text"
                  inputMode="decimal"
                  placeholder="0–100"
                  style={{ height: 32, border: "1px solid #d5d5d5", width: 90, padding: "0 10px", borderRadius: 6 }}
                />
              </div>
              <button
                onClick={() => handleDeleteRow(index)}
                style={{ height: 32, marginTop: 16, padding: "0 10px", backgroundColor: "#ffe2e2", color: "#b91c1c", borderRadius: 6, marginRight: 10 }}
              >
                Удалить
              </button>
            </div>

          </div>
        ))}
      </div>

      <div>
        <button
          onClick={handleAddRow}
          style={{ height: 34, padding: "0 14px", backgroundColor: "#dfe8ff", color: "#3f73f9", borderRadius: 6 }}
        >
          + Добавить цель
        </button>
      </div>
    </div>
  );
};


const PrgStatsData = ({ campaignData }) => {
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [filterArr, setFilter] = useState([]);
  const [upd, setUpd] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      let date_start, date_end;
      if (filtersValue.date.date_start === "" || filtersValue.date.date_end === "") {
        date_end = Math.floor(new Date().getTime() / 1000);
        date_start = Math.floor(date_end - (7 * 24 * 60 * 60 * 1000) / 1000);
      } else {
        date_start = Math.floor((new Date(filtersValue.date.date_start).getTime() / 1000 + 86400));
        date_end = Math.floor((new Date(filtersValue.date.date_end).getTime() / 1000) + 86400);
      }
      const reachResponse = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/?campaign_id=${campaignData.id}&report_type=internal&target_type=REACH&date_from=${date_start}&date_to=${date_end}${filtersValue.partner_name ? `&partner_name=${filtersValue.partner_name}` : ""}`, {
        method: "GET",
        headers: myHeaders,
      });
      const trafficResponse = await fetch(`${DOMAIN_API_HOST}/api/v1/ssp-stats/?campaign_id=${campaignData.id}&report_type=internal&target_type=TRAFFIC&date_from=${date_start}&date_to=${date_end}${filtersValue.partner_name ? `&partner_name=${filtersValue.partner_name}` : ""}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (reachResponse.ok && trafficResponse.ok) {
        const reachData = await reachResponse.json();
        const trafficData = await trafficResponse.json();
        const combinedData = reachData.map(reachItem => {
          const correspondingTrafficItem = trafficData.find(trafficItem => trafficItem.date === reachItem.date);
          return {
            date: reachItem.date,
            clicks: correspondingTrafficItem ? correspondingTrafficItem.amount : 0,
            views: reachItem.amount || 0,
          };
        });
        setFilter(combinedData);
      }
    }
    fetchData();
  }, [upd]);

  useEffect(() => {
    // if (filtersValue.date.date_start === "" || filtersValue.date.date_end === "") return;
    const result = Object.entries(filtersValue).reduce(
      (acc, [key, value]) => {
        switch (key) {
          case "date":
            if (value === "") return acc;
            return filterStatsDate(value, acc);
          case "partner_name":
            if (value === "") return acc;
            return filterStatsPartner(value, acc);
          default:
            return acc;
        }
      },
      [...filterArr]
    );
    setFilter(result);
  }, [filtersValue]);

  const columns = [
    {
      Header: "Просмотры",
      accessor: "clicks",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Показы",
      accessor: "views",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Дата",
      accessor: "date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    }
  ];

  const handleDateChange = (value) => {
    setValue((prev) => ({
      ...prev,
      date: { date_end: value[1] ?? "", date_start: value[0] ?? "" },
    }));
    setUpd(!upd);
  };

  function getTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA > dateB ? -1 : 1;
    });

    return sortedData.map((el) => {
      return {
        clicks: <div className="td">{el.clicks ? el.clicks : "-"}</div>,
        views: <div className="td">{el.views ? el.views : "-"}</div>,
        date: <div className="td">{el.date ? dateFormat(Date.parse(el.date), "dd/MM/yyyy") : "-"}</div>
      };
    });
  }


  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
      <DateFromTo withoutStartDate={true} handleChange={handleDateChange} />
      <Box sx={{ width: 175 }}>
        <FormControl fullWidth size="small">
          <InputLabel
            id="demo-select-small-label"
            sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
          >
            Партнёр
          </InputLabel>
          <Select
            style={{
              height: 32,
              background: "#FFFFFF",
              borderColor: "transparent",
            }}
            sx={{
              "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
            }}
            label="Партнёр"
            id="demo-select-small-label"
            value={filtersValue.partner_name}
            onChange={(e) => {
              console.log(e.target.value);
              setValue((prev) => ({ ...prev, partner_name: e.target.value }))
              setUpd(!upd);
            }}
          >
            <MenuItem value={""}>Все партнёры</MenuItem>
            <MenuItem value={"marketplace-su"}>Market-place.su</MenuItem>
            <MenuItem value={"contema"}>Contema</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <DataTable data={getTableData()} columns={columns} />
    </div>
  )
}





const BlackList = ({ campaignData }) => {
  const [blacklist, setBlacklist] = useState([]);
  const [error, setError] = useState(null);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Bearer " + localStorage.getItem("admin_token")
  );


  const listsSchema = z.array(
    z
      .string()
      .min(3, "Минимум 3 символа.")
      .max(255, "Максимальная длина домена 255 символов.")
      .regex(
        /^(https?:\/\/)?(?!.*\.\.)(?=[^\s]{4,253}$)(?=.{2,}\.[^.]{2,}$)([a-zA-Zа-яё0-9-]{1,63}\.?){2,3}[^.\s]{2,}$/,
        "Некорректная ссылка на сайт."
      )
      .refine((value) => !blacklist.includes(value), "Такой сайт уже добавлен.")
  );

  const addToBlacklist = async (input) => {
    const items = input
      .split(" ")
      .map((item) => item.trim())
      .filter(Boolean);
    try {
      listsSchema.parse(items);
      setBlacklist((prev) => [...new Set([...prev, ...items])]);
      setError(null);
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update-in-campaign?campaign_id=${campaignData.id}`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ blacklist_domains: [...new Set([...blacklist, ...items])] }),
      });
    } catch (error) {
      setError(error.errors[0].message);
    }
  };


  const removeFromBlacklist = async (item) => {
    setBlacklist((prev) => prev.filter((i) => i !== item));
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update-in-campaign?campaign_id=${campaignData.id}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ blacklist_domains: blacklist.filter((i) => i !== item) }),
    });
  };

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch_blacklists?_type=domains&campaign_id=${campaignData.id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        setBlacklist(data);
      }
    }
    fetchData();
  }, []);

  return (
    <div style={{ border: "1px solid #e0e0e0", padding: "20px", borderRadius: "10px" }}>
      <h3>Полное совпадение</h3>
      <div>
        <input
          onInput={() => setError(null)}
          style={{ marginTop: "10px", width: "200px", border: "1px solid grey" }}
          placeholder="Ссылки через пробел"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addToBlacklist(e.target.value);
              e.target.value = "";
            }
          }}
          type="text"
        />
        {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
      </div>

      <h3 style={{ marginTop: "20px" }}>Список сайтов:</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px", width: "100%" }}>
        {blacklist.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", background: "#e0e0e063", width: "max-content", padding: "10px 20px", borderRadius: "20px" }}>
            {item}
            <svg
              onClick={() => removeFromBlacklist(item)}
              style={{ cursor: "pointer" }}
              xmlns="http://www.w3.org/2000/svg"
              width="16" height="16"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};



const PartialList = ({ campaignData }) => {
  const [blacklist, setBlacklist] = useState([]);
  const [error, setError] = useState(null);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Bearer " + localStorage.getItem("admin_token")
  );

  const listsSchema = z.array(
    z
      .string()
      .min(3, "Минимум 3 символа.")
      .max(255, "Максимальная длина текста 255 символов.")
      .refine((value) => !blacklist.includes(value), "Такой текст уже добавлен.")
  );

  const addToBlacklist = async (input) => {
    const items = input
      .split(" ")
      .map((item) => item.trim())
      .filter(Boolean);
    try {
      listsSchema.parse(items);
      setBlacklist((prev) => [...new Set([...prev, ...items])]);
      setError(null);
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update-in-campaign?campaign_id=${campaignData.id}`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ blacklist_partial: [...new Set([...blacklist, ...items])] }),
      });
    } catch (error) {
      setError(error.errors[0].message);
    }
  };

  const removeFromBlacklist = async (item) => {
    setBlacklist((prev) => prev.filter((i) => i !== item));
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update-in-campaign?campaign_id=${campaignData.id}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ blacklist_partial: blacklist.filter((i) => i !== item) }),
    });
  };

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch_blacklists?_type=partial&campaign_id=${campaignData.id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        setBlacklist(data);
      }
    }
    fetchData();
  }, []);

  return (
    <div style={{ border: "1px solid #e0e0e0", padding: "20px", borderRadius: "10px" }}>
      <h3>Частичное совпадение</h3>
      <div>
        <input
          onInput={() => setError(null)}
          style={{ marginTop: "10px", width: "200px", border: "1px solid grey" }}
          placeholder="Введите текст через пробел"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addToBlacklist(e.target.value);
              e.target.value = "";
            }
          }}
          type="text"
        />
        {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
      </div>

      <h3 style={{ marginTop: "20px" }}>Список текстов:</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px", width: "100%" }}>
        {blacklist.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", background: "#e0e0e063", width: "max-content", padding: "10px 20px", borderRadius: "20px" }}>
            {item}
            <svg
              onClick={() => removeFromBlacklist(item)}
              style={{ cursor: "pointer" }}
              xmlns="http://www.w3.org/2000/svg"
              width="16" height="16"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};



const PartnersSettings = ({ campaign_id }) => {
  const [partners, setPartners] = useState([]);
  const debounceTimers = useRef({});
  const updateQueues = useRef({});
  const isUpdating = useRef({});

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/get-local-settings?_id=${campaign_id}`, {
        method: "GET",
        headers: myHeaders
      });
      const data = await response.json();
      setPartners(data);
    }
    fetchData();
  }, []);




  const debounceUpdate = (field, partner_id, callback, delay = 500) => {
    const uniqueKey = `${field}-${partner_id}`;
    clearTimeout(debounceTimers.current[uniqueKey]);

    debounceTimers.current[uniqueKey] = setTimeout(() => {
      if (!updateQueues.current[uniqueKey]) updateQueues.current[uniqueKey] = [];
      updateQueues.current[uniqueKey].push(callback);
      processUpdateQueue(uniqueKey);
    }, delay);
  };

  const processUpdateQueue = async (uniqueKey) => {
    if (isUpdating.current[uniqueKey] || !updateQueues.current[uniqueKey] || updateQueues.current[uniqueKey].length === 0) return;

    isUpdating.current[uniqueKey] = true;

    while (updateQueues.current[uniqueKey].length > 0) {
      const callback = updateQueues.current[uniqueKey].shift();
      await callback();
    }

    isUpdating.current[uniqueKey] = false;
  };

  const handleChange = (field, value, partner_id) => {
    debounceUpdate(field, partner_id, async () => {
      console.log(field, value, partner_id);
      await updateFields({ [field]: value }, partner_id);
    });
  };

  const updateFields = async (fields, partner_id) => {
    if (partner_id === null) return;
    console.debug(fields, partner_id);
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update-in-campaign?_id=${partner_id}&campaign_id=${campaign_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
      body: JSON.stringify(fields),
    });
  };



  const columns = [
    {
      Header: "Наименование партнёрской сети",
      accessor: "display_name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
      isSticky: true,
    },
    {
      Header: "CPM",
      accessor: "cpm",
      maxWidth: 400,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "Статус активности",
      accessor: "active_status",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    }
  ];


  const FormatNumberInput = ({ el, handleChange, fieldName }) => {
    const [formattedValue, setFormattedValue] = useState('');

    useEffect(() => {
      setFormattedValue(el[fieldName].toLocaleString('ru-RU'));
    }, [el, fieldName]);

    const handleInputChange = (e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      const numberValue = Number(rawValue);

      const formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

      setFormattedValue(formatted);
      handleChange(fieldName, numberValue, el.id);
    };

    return (
      <div className="td">
        <input
          onChange={handleInputChange}
          defaultValue={el[fieldName]}
          value={formattedValue}
          type="text"
          style={{
            height: 25,
            border: "1px solid #d5d5d5",
            width: "100%",
            padding: "10px"
          }}
        />
      </div>
    );
  };


  function getTableData() {
    return partners.map((el) => {
      return {
        display_name: <div className="td">{el.display_name}</div>,
        cpm: (
          <FormatNumberInput
            el={el}
            fieldName="cpm"
            handleChange={handleChange}
          />
        ),
        active_status: (
          <div className="td">
            <Switch defaultChecked={el.enabled} onChange={(e) => handleChange('enabled', e.target.checked, el.id)} />
          </div>
        ),
      };
    });
  }

  return (
    <div style={{ overflowX: "auto", width: "100%", height: "94%", overflowY: "auto" }}>
      <DataTable data={getTableData()} columns={columns} />
    </div>
  )
}


const OpenModal = ({ openModal, setOpenModal, type, campaignData }) => {
  let modalContent;

  const ModalStats = ({ openModal, setOpenModal, children }) => {
    const closeModal = () => setOpenModal(false);

    const modalStyles = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: openModal ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    };

    const modalContentStyles = {
      backgroundColor: '#fff',
      width: '80%',
      maxWidth: 400,
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    };

    return (
      <div style={modalStyles} onClick={closeModal}>
        <div style={modalContentStyles} onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  };

  switch (type) {
    case "blacklist":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18, marginBottom: 20 }}>
              Черный список по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && (
              <div style={{ display: "flex", flexDirection: "column", width: "900px", gap: 20 }}>
                <BlackList campaignData={campaignData} />
                <PartialList campaignData={campaignData} />
              </div>
            )}
          </Box>

        </ModalStats>
      );
      break;

    case "partners_settings":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18, marginBottom: 20 }}>
              Настройка SSP по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && <PartnersSettings campaign_id={campaignData.id} />}
          </Box>

        </ModalStats>
      );
      break;

    case "banners_stats":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18 }}>
              Статистика баннеров по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && <BannersStatsData campaignData={campaignData} />}
          </Box>

        </ModalStats>
      );
      break;

    case "postview_settings":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18 }}>
              PostView настройка по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && <SettingsPostView campaignData={campaignData} />}
          </Box>

        </ModalStats>
      );
      break;

    case "prg_stats":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={decisionStyles}>
            <h3 style={{ fontSize: 18 }}>
              Статистика с Programmatic по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && <PrgStatsData campaignData={campaignData} />}
          </Box>

        </ModalStats>
      );
      break;

    case "open_creative":
      modalContent = (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Объявления кампании
            </Typography>
            <div style={{ display: "flex", flexDirection: "column", marginTop: 10 }}>
              {Object.keys(campaignData).length !== 0 && <AdsForManagers campaignId={campaignData.id} />}
            </div>
          </Box>
        </Modal>
      )
      break;

    case "open_campaign":
      modalContent = (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={campaignStyles}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Данные РК
            </Typography>
            <Box
              style={{ gap: 20, marginBottom: 30, marginTop: 10 }}
              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
            >
              {Object.keys(campaignData).length !== 0 && <CampaignData data={campaignData} />}
            </Box>
          </Box>
        </Modal>
      )
      break;

    case "post_view":
      console.log(campaignData)
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={postviewStyles}>
            <h3 style={{ fontSize: 18 }}>
              Post-view отчёт по кампании - {campaignData.name}
            </h3>
            {Object.keys(campaignData).length !== 0 && <PostViewData campaignData={campaignData} />}
          </Box>
        </ModalStats>
      );
      break;


    default:
      modalContent = null;
  }

  return modalContent;
};

function Reach() {
  const [filterArr, setFilter] = useState([]);
  const [arrCampaigns, setCampaigns] = useState([]);
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [campaignData, setCampaignData] = useState({});
  const debounceTimers = useRef({});
  const updateQueues = useRef({});
  const isUpdating = useRef({});
  const [upd, setUpd] = useState(false);
  const [project, setProject] = useState("all");
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const handleProjectChange = useCallback((e) => {
    const newProject = e.target.value;
    requestAnimationFrame(() => {
      setProject(newProject);
    });
  }, []);

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      requestAnimationFrame(() => {
        if (isMounted) setLoading(true);
      });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      try {
        const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/ready_for_ssp?project=${project}`, {
          method: "GET",
          headers: myHeaders,
        });
        if (res.ok) {
          const data = await res.json();
          if (isMounted) {
            setCampaigns(data);
            setFilter(data);
          }
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [upd, project]);

  useEffect(() => {
    const result = Object.entries(filtersValue).reduce(
      (acc, [key, value]) => {
        switch (key) {
          case "date":
            if (value === "") return acc;
            return filterDate(value, acc);
          case "full_name":
            if (value === "") return acc;
            return filterEmploye(value, acc);
          default:
            return acc;
        }
      },
      [...arrCampaigns]
    );
    setFilter(result);
  }, [filtersValue, arrCampaigns]);

  const fetchCampaign = async (campaign_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaign_id}`, {
      method: "GET",
      headers: myHeaders,
    });
    if (res.ok) {
      return await res.json();
    }
  }

  const FormatNumberInput = ({ el, handleChange, fieldName }) => {
    const [formattedValue, setFormattedValue] = useState('');

    useEffect(() => {
      setFormattedValue(el[fieldName].toLocaleString('ru-RU'));
    }, [el, fieldName]);

    const handleInputChange = (e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      const numberValue = Number(rawValue);

      const formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

      setFormattedValue(formatted);
      handleChange(fieldName, numberValue, el.id);
    };

    return (
      <div className="td">
        <input
          onChange={handleInputChange}
          defaultValue={el[fieldName]}
          value={formattedValue}
          type="text"
          style={{
            height: 25,
            border: "1px solid #d5d5d5",
            width: "100%",
            padding: "10px"
          }}
        />
      </div>
    );
  };


  const debounceUpdate = (field, campaign_id, callback, delay = 500) => {
    const uniqueKey = `${field}-${campaign_id}`;
    clearTimeout(debounceTimers.current[uniqueKey]);

    debounceTimers.current[uniqueKey] = setTimeout(() => {
      if (!updateQueues.current[uniqueKey]) updateQueues.current[uniqueKey] = [];
      updateQueues.current[uniqueKey].push(callback);
      processUpdateQueue(uniqueKey);
    }, delay);
  };

  const processUpdateQueue = async (uniqueKey) => {
    if (isUpdating.current[uniqueKey] || !updateQueues.current[uniqueKey] || updateQueues.current[uniqueKey].length === 0) return;

    isUpdating.current[uniqueKey] = true;

    while (updateQueues.current[uniqueKey].length > 0) {
      const callback = updateQueues.current[uniqueKey].shift();
      await callback();
    }

    isUpdating.current[uniqueKey] = false;
  };

  const handleChange = (field, value, campaign_id) => {
    setCampaigns((prev) =>
      prev.map((campaign) =>
        campaign.id === campaign_id ? { ...campaign, [field]: value } : campaign
      )
    );
    setFilter((prev) =>
      prev.map((campaign) =>
        campaign.id === campaign_id ? { ...campaign, [field]: value } : campaign
      )
    );
    debounceUpdate(field, campaign_id, async () => {
      console.log(field, value, campaign_id);
      const response = await updateFields({ [field]: value }, campaign_id);
      if (!response || !response.ok) {
        setUpd((prev) => !prev);
      }
    });
  };

  const updateFields = async (fields, campaign_id) => {
    if (campaign_id === null) return;
    console.debug(fields, campaign_id);
    return await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaign_id}/update_ssp`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
      body: JSON.stringify(fields),
    });
  };

  const handleAccessToken = async (campaign_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    )
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/auth/access-token-by-campaign/${campaign_id}`, {
      method: "get",
      headers: myHeaders
    })
    const data = await response.json()
    localStorage.setItem("token", data.access_token);
    return window.open("/")
  }

  // Расчет общих показателей только по кампаниям с ssp_date_end позже сегодняшнего дня
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const totalPlanViews = filterArr.reduce((sum, el) => {
    const endDate = el.ssp_date_end ? new Date(el.ssp_date_end) : null;
    return sum + (endDate && endDate > today ? (el.ssp_plan_views_count || 0) : 0);
  }, 0);

  const totalDayLimit = filterArr.reduce((sum, el) => {
    const endDate = el.ssp_date_end ? new Date(el.ssp_date_end) : null;
    return sum + (endDate && endDate > today ? (el.ssp_views_count_day_limit || 0) : 0);
  }, 0);

  const totalDayViews = filterArr.reduce((sum, el) => {
    const endDate = el.ssp_date_end ? new Date(el.ssp_date_end) : null;
    return sum + (endDate && endDate > today ? (el.ssp_views_count_day || 0) : 0);
  }, 0);

  const totalViews = filterArr.reduce((sum, el) => {
    const endDate = el.ssp_date_end ? new Date(el.ssp_date_end) : null;
    return sum + (endDate && endDate > today ? (el.ssp_views_count || 0) : 0);
  }, 0);

  const columns = [
    {
      Header: "Перейти в ЛК",
      accessor: "redirect",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
      isSticky: true,
    },
    {
      Header: "Название РК",
      accessor: "campaign_name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
      isSticky: true,
    },
    {
      Header: "Сайт",
      accessor: "site",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Почта клиента",
      accessor: "email",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Открыть объявления",
      accessor: "open_creative",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Post-view отчёт",
      accessor: "post_view",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Статистика по объявлениям",
      accessor: "banners_stats",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Настройка post-view",
      accessor: "postview_settings",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Гео",
      accessor: "ssp_geo_cities",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Настройка SSP",
      accessor: "ssp_plan_cpm",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Черный список сайтов",
      accessor: "blacklist",
      maxWidth: 400,
      minWidth: 80,
      width: 135,
    },
    {
      Header: (
        <div>
          <div>Плановые показы</div>
          <div style={{ fontSize: '13px', opacity: 0.5, marginTop: '2px' }}>
            ( {totalPlanViews.toLocaleString('ru-RU')} )
          </div>
        </div>
      ),
      accessor: "ssp_plan_views_count",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: (
        <div>
          <div>Дневной лимит по показам</div>
          <div style={{ fontSize: '13px', opacity: 0.5, marginTop: '2px' }}>
            ( {totalDayLimit.toLocaleString('ru-RU')} )
          </div>
        </div>
      ),
      accessor: "ssp_views_count_day_limit",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: (
        <div>
          <div>Факт. показов в день</div>
          <div style={{ fontSize: '13px', opacity: 0.5, marginTop: '2px' }}>
            ( {totalDayViews.toLocaleString('ru-RU')} )
          </div>
        </div>
      ),
      accessor: "ssp_views_count_day",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: (
        <div>
          <div>Всего показов</div>
          <div style={{ fontSize: '13px', opacity: 0.5, marginTop: '2px' }}>
            ( {totalViews.toLocaleString('ru-RU')} )
          </div>
        </div>
      ),
      accessor: "ssp_views_count",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Частота показов",
      accessor: "ssp_show_frequency",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Дата начала цикла",
      accessor: "start_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Дата окончания цикла",
      accessor: "end_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Статус кампании",
      accessor: "ssp_active",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Сброс статистики",
      accessor: "reset",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Удалить с SSP",
      accessor: "delete_from_ssp",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    }
  ];

  const handleDateChange = (value) => {
    setValue((prev) => ({
      ...prev,
      date: { date_end: value[1] ?? "", date_start: value[0] ?? "" },
    }));
  };

  const handleStatsReset = async (campaign_id) => {
    return await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaign_id}/ssp_reset`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
    });
  }

  const handleCampaignRemove = async (campaign_id) => {
    return await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaign_id}/ssp_remove`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
    });
  }

  function getTableData() {
    return filterArr.map((el) => {
      return {
        id: el.id,
        _ssp_active: el.ssp_active,
        campaign_name: <div className="td">{el.name}</div>,
        email: <div className="td">{el.campaign_creator_email}</div>,
        site: <div className="td">{el.site}</div>,
        started_date: <div className="td">{dateFormat(Date.parse(el.created_at), "dd/MM/yyyy")}</div>,
        ssp_geo_cities: <CitiesTreeSelect defaultValue={el.ssp_geo_cities} handleChange={handleChange} campaign_id={el.id} field="ssp_geo_cities" />,
        open_creative: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("open_creative")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        redirect: <button
          onClick={() => handleAccessToken(el.id)}
          style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
          Перейти
        </button>,
        post_view: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("post_view")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        banners_stats: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("banners_stats")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        postview_settings: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("postview_settings")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        ssp_plan_cpm: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("partners_settings")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        blacklist: (
          <button
            onClick={async () => {
              const data = await fetchCampaign(el.id)
              setCampaignData(data)
              setOpenModal(true)
              setModalType("blacklist")
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        ssp_show_frequency: (
          <FormatNumberInput
            el={el}
            fieldName="ssp_show_frequency"
            handleChange={handleChange}
          />
        ),
        ssp_views_count: (
          <div className="td">
            {el.ssp_views_count.toLocaleString('ru-RU')}
            <p style={{ fontSize: 13, opacity: 0.5, marginTop: 5 }}>{el.ssp_consumption.toLocaleString('ru-RU')} ₽</p>
          </div>
        ),
        ssp_plan_views_count: (
          <div className="td">
            {el.ssp_plan_views_count.toLocaleString('ru-RU')}
            <p style={{ fontSize: 13, opacity: 0.5, marginTop: 5 }}>{el.ssp_plan_consumption.toLocaleString('ru-RU')} ₽</p>
          </div>
        ),
        ssp_views_count_day_limit: (
          <div className="td">
            {el.ssp_views_count_day_limit.toLocaleString('ru-RU')}
            <p style={{ fontSize: 13, opacity: 0.5, marginTop: 5 }}>{el.ssp_plan_consumption_day.toLocaleString('ru-RU')} ₽</p>
          </div>
        ),
        ssp_views_count_day: (
          <div className="td" style={{ color: !el.ssp_active && (el.ssp_views_count_day_limit <= el.ssp_views_count_day) ? "green" : "black" }}>
            {Math.min(
              el.ssp_views_count_day ?? 0,
              el.ssp_views_count_day_limit ?? Number.MAX_SAFE_INTEGER
            ).toLocaleString('ru-RU')}
            <p style={{ fontSize: 13, opacity: 0.5, marginTop: 5 }}>{el.ssp_consumption_day.toLocaleString('ru-RU')} ₽</p>
          </div>
        ),
        start_cycle_date: (
          <div className="td" style={{ height: 40 }}>
            <DatePickerTest
              defaultValue={el.ssp_date_start}
              onChange={(date) => {
                const formattedDate = new Date(date).toISOString().split('T')[0];
                handleChange('ssp_date_start', formattedDate, el.id);
              }}
            />
          </div>
        ),
        end_cycle_date: (
          <div className="td" style={{ height: 40 }}>
            <DatePickerTest
              defaultValue={el.ssp_date_end}
              onChange={(date) => {
                const formattedDate = new Date(date).toISOString().split('T')[0];
                handleChange('ssp_date_end', formattedDate, el.id);
              }}
            />
          </div>
        ),
        ssp_active: (
          <div className="td">
            <Switch checked={el.ssp_active} onChange={(e) => handleChange('ssp_active', e.target.checked, el.id)} />
          </div>
        ),
        reset: (
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}
            onClick={async () => {
              const answer = await confirm("Вы действительно хотите сбросить статистику?")
              if (!answer) return;
              const res = await handleStatsReset(el.id)
              if (res.status === 200) {
                enqueueSnackbar("Статистика успешно сброшена", {
                  variant: "success",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
                setUpd((prev) => !prev);
              } else {
                enqueueSnackbar("Произошла ошибка", {
                  variant: "error",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
              }
            }}>
            Сбросить
          </button>
        ),
        delete_from_ssp: (
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}
            onClick={async () => {
              const answer = await confirm("Вы действительно хотите удалить кампанию с таблицы ?")
              if (!answer) return;
              const res = await handleCampaignRemove(el.id)
              if (res.status === 200) {
                enqueueSnackbar("Кампания успешно удалена с таблицы", {
                  variant: "success",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
                setUpd((prev) => !prev);
              } else {
                enqueueSnackbar("Произошла ошибка", {
                  variant: "error",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
              }
            }}>
            Удалить
          </button>
        )
      };
    });
  }
  return (
    <div className="logs" style={{ width: "100%", height: "97%" }}>
      <div className="filters">
        <div className="searchDate">
          <DateFromTo withoutStartDate={true} handleChange={handleDateChange} />
        </div>
        <div style={{ marginLeft: "-40px", marginTop: "-16px" }}>
          <ProjectSelect
            value={project}
            onChange={handleProjectChange}
          />
        </div>
      </div>
      <div style={{ overflowX: "auto", width: "100%", height: "94%", overflowY: "auto", position: "relative" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1000,
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <DataTable
          data={getTableData()}
          columns={columns}
          getRowProps={(row) => {
            if (row.original?._ssp_active) {
              return {
                style: {
                  borderLeft: '5px solid #3F73F9',
                }
              };
            }
            return {};
          }}
        />
      </div>
      <OpenModal openModal={openModal} setOpenModal={setOpenModal} type={modalType} campaignData={campaignData} />
    </div>
  );
}

export default Reach;
